export const SHOW_NOTIFICATION_SUCCESS = 'SHOW_NOTIFICATION_SUCCESS'
export const SHOW_NOTIFICATION_ERROR = 'SHOW_NOTIFICATION_ERROR'
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'

export enum TypeNotification {
  OK = 'OK',
  ERROR = 'ERROR',
}

export interface SelectedItem {
  type: string
  label: string
  creditos: string
  color: string
  icon: string
}

export interface NotificationCartState {
  open: boolean
  type: string
  selectedItem: null | SelectedItem
}
export const InitialState: NotificationCartState = {
  open: false,
  type: '',
  selectedItem: null,
}

export interface ShowNotificationError {
  type: typeof SHOW_NOTIFICATION_ERROR
  payload: null
}

export interface ShowNotificationSuccess {
  type: typeof SHOW_NOTIFICATION_SUCCESS
  payload: SelectedItem
}

export interface HideNotification {
  type: typeof HIDE_NOTIFICATION
  payload: null
}

export type NotificationCartActions = ShowNotificationSuccess | ShowNotificationError | HideNotification
